/**
 * Determines whether floats are "close enough" to being equal given some threshold
 */
export function floatEquals(a: number, b: number, threshold: number) {
	return Math.abs(a - b) < threshold;
}
